module.exports = __webpack_public_path__ + "static/GT-Haptik-Bold-Rotalic-a0144a52a8ca38be42e200ac79491032.woff";